import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../../../reduxStore/redux-hooks';
import {
  updateFileUploadState,
  updateFileSelectionState,
  updateDatasetState,
} from '../../../../../reduxStore/slices/FileUploadSlice';
import { Radio, RadioGroup, FormControlLabel, FormControl, SelectChangeEvent } from '@mui/material';

interface RadioSelectProps {
  datasetRadioSelect: string;
  setdatasetRadioSelect: (radioSelectMessage: string) => void;
}

const RadioSelect: React.FC<RadioSelectProps> = ({ datasetRadioSelect, setdatasetRadioSelect }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { addFiles } = useAppSelector((state) => state.dataset.editDataset);
  const { isCustomAppSelected } = useAppSelector((state) => state.customApps.choosenCustomApp);

  const handleDatasetSelect = (event: SelectChangeEvent<HTMLInputElement>) => {
    const selectedRadioButtonValue = (event.target as HTMLInputElement).value;
    setdatasetRadioSelect(selectedRadioButtonValue);
    if (
      selectedRadioButtonValue === t('fileUpload.newDataset') ||
      selectedRadioButtonValue === t('fileUpload.sharePointDataset')
    ) {
      dispatch(
        updateFileSelectionState({
          isDatasetButtonDisabled: false,
        })
      );
    } else {
      dispatch(
        updateFileUploadState({
          listOfFilesInSelectedDataset: [],
          listOfFilteredUploadedFilesExistInDataset: [],
        })
      );

      dispatch(
        updateDatasetState({
          selectedDatasetId: '',
        })
      );

      dispatch(
        updateFileSelectionState({
          isReplaceFileCheckboxChecked: false,
          isDatasetButtonDisabled: true,
        })
      );
    }
  };

  return (
    <FormControl>
      <RadioGroup
        row
        aria-labelledby="dataset-row-radio-buttons-group-label"
        name={t('fileUpload.radioGroup')}
        defaultValue={datasetRadioSelect}
        sx={{ display: 'flex', gap: '2rem' }}
        onChange={handleDatasetSelect}
      >
        <FormControlLabel
          value={t('fileUpload.newDataset')}
          control={<Radio disabled={addFiles} />}
          label={t('fileUpload.newDataset')}
        />
        <FormControlLabel
          value={t('fileUpload.sharePointDataset')}
          control={<Radio />}
          label={t('fileUpload.sharePointDataset')}
          disabled={isCustomAppSelected}
        />
      </RadioGroup>
    </FormControl>
  );
};

export default RadioSelect;
